export const WIDGET_SETTINGS = "WIDGET_SETTINGS";
export const BORROWER_DETAILS = "BORROWER_DETAILS";
export const LOAN_DETAILS = "LOAN_DETAILS";
export const WEB_SETTINGS = "WEB_SETTINGS";
export const MONO_WIDGET_DATA = "MONO_WIDGET_DATA";
export const WEB_AGGREGATOR_SETTINGS = "WEB_AGGREGATOR_SETTINGS";
